// udp-container-query-grid-item.tsx
import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'udp-container-query-grid-item',
  styleUrl: 'udp-container-query-grid-item.css',
  shadow: true,
})
export class UdpContainerQueryGridItem {
  @Prop() span?: { [breakpoint: number]: number } = {};

  private getSpanStyles(): string {
    return Object.entries(this.span)
      .map(
        ([breakpoint, cols]) => `
  @container (min-width: ${breakpoint}px) {
    :host {
      --udp-grid-item-span: ${cols};
    }
  }`,
      )
      .join('\n');
  }

  render() {
    return (
      <Host>
        <style>{this.getSpanStyles()}</style>
        <slot></slot>
      </Host>
    );
  }
}
